document.addEventListener("DOMContentLoaded", function () {
  // -----------------------------
  // 1. Get current page title from Liquid
  // -----------------------------
  var constructsSection = document.querySelector(".constructs");
  var pageTitle = constructsSection.dataset.title; // product.title inject hoga
  var rawData = window.glossaryData || [];

  
  var currentBook = pageTitle.split("Chapter")[0].trim();

  var data = [];
  if (pageTitle.includes("Chapter")) {
    
    var currentChapter = pageTitle.replace(currentBook, "").trim();
    data = rawData.filter(function (item) {
      return item.BookTitle === currentBook && item.ChapterTitle === currentChapter;
    });
  } else {
    
    data = rawData.filter(function (item) {
      return item.BookTitle === currentBook;
    });
  }

  // -----------------------------
  // 2. DOM Elements
  // -----------------------------
  var browseToggle = document.getElementById("browse-toggle");
  var browseLetters = document.getElementById("browse-letters");
  var searchInput = document.getElementById("myInput");
  var suggestions = document.getElementById("search-suggestions");

  var popup = document.querySelector(".constructs-popup");
  var popupContent = document.querySelector(".constructs-popup-content .dataUpdate");

  var lastResults = [];
  var inBrowseMode = false;

  // -----------------------------
  // 3. Browse by Alphabet
  // -----------------------------
  var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  var activeLetters = new Set(data.map(item => item.Term[0].toUpperCase()));

  letters.forEach(function (letter) {
    var li = document.createElement("li");
    li.textContent = letter;

    if (!activeLetters.has(letter)) {
      li.classList.add("disabled"); // grey inactive letters
    } else {
      li.addEventListener("click", function () {
        var results = data.filter(function (item) {
          return item.Term[0].toUpperCase() === letter;
        });
        lastResults = results;
        inBrowseMode = true;
        showTermList(results);
        popup.classList.add("active");
        browseLetters.classList.add("hidden");
      });
    }

    browseLetters.appendChild(li);
  });

  browseToggle.addEventListener("click", function () {
    browseLetters.classList.toggle("hidden");
  });

  // -----------------------------
  // 4. Search
  // -----------------------------
  searchInput.addEventListener("input", function () {
    var query = this.value.toLowerCase();
    suggestions.innerHTML = "";
    browseLetters.classList.add("hidden");
    if (!query) return;
    var filtered = data.filter(function (item) {
      return item.Term.toLowerCase().indexOf(query) !== -1;
    });
    filtered.forEach(function (item) {
      var li = document.createElement("li");
      li.textContent = item.Term;
      li.addEventListener("click", function () {
        inBrowseMode = false;
        showResults([item]);
        popup.classList.add("active");
        suggestions.innerHTML = "";
      });
      suggestions.appendChild(li);
    });
  });

  searchInput.addEventListener("focus", function () {
    browseLetters.classList.add("hidden");
  });

  // -----------------------------
  // 5. Show term list
  // -----------------------------
  function showTermList(results) {
    if (!results.length) {
      popupContent.innerHTML = "<p>No Record Available!</p>";
      return;
    }

    var html = `
      <div class="term-list-header">
        <p class="term-list-title">Select a Term <a class="article_close" href="javascript:void(0)">×</a></p>
      </div>
      <ul class='term-list'>
    `;
    results.forEach(function (item) {
      html += `<li class="term-item" data-term="${item.Term}">${item.Term}</li>`;
    });
    html += "</ul>";
    popupContent.innerHTML = html;

    popupContent.querySelectorAll(".term-item").forEach(function (li) {
      li.addEventListener("click", function () {
        var term = this.getAttribute("data-term");
        var detail = data.filter(x => x.Term === term);
        showResults(detail);
      });
    });

    var closeBtn = popupContent.querySelector(".article_close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        popup.classList.remove("active");
      });
    }
  }

  // -----------------------------
  // 6. Show details
  // -----------------------------
  function showResults(results) {
    if (!results.length) {
      popupContent.innerHTML = "<p>No Record Available!</p>";
      return;
    }

    var html = `
      <div class="article_content">
        <div class="article_header">
          <span class="article_heading">Details</span>
          <a class="article_close" href="javascript:void(0)">×</a>
        </div>
        <ul>
    `;

    results.forEach(function (item) {
      html += `
        <li>
          <div class="article_body"><strong>${item.Term}</strong><br>${item.Content}</div>
          <a class="article_addon-link" href="${item.URL}">
            <figure><img src="${item.Thumbnail}" alt="${item.Term}"></figure>
            <div class="article_addon-content">
              <p class="modalHeading">${item.ChapterTitle}</p>
              <p class="modalTitle">${item.BookTitle}</p>
              <span><u><i> Author: ${item.Author}</i></u></span>
            </div>
          </a>
        </li>
      `;
    });

    html += `
        </ul>
        <div class="closeBtn">
          <a class="article_close redbtn" href="javascript:void(0);">Close Window</a>
        </div>
      </div>
    `;

    popupContent.innerHTML = html;

    popupContent.querySelectorAll(".article_close").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (inBrowseMode && lastResults.length) {
          showTermList(lastResults);
        } else {
          popup.classList.remove("active");
        }
      });
    });
  }

  // -----------------------------
  // 7. Close on background click
  // -----------------------------
  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.classList.remove("active");
    }
  });

  // -----------------------------
  // 8. Hide A-Z when clicking outside
  // -----------------------------
  document.addEventListener("click", function (e) {
    var target = e.target;
    if (!browseToggle.contains(target) && !browseLetters.contains(target)) {
      browseLetters.classList.add("hidden");
    }
  });
});
